import React from 'react';
import classNames from 'classnames';
import { IS_DEVELOPMENT_BUILD } from '@jwp/ott-common/src/utils/common';

import MarkdownComponent from '../MarkdownComponent/MarkdownComponent';

import styles from './Footer.module.scss';

type Props = {
  text: string;
};

const Footer: React.FC<Props> = ({ text }) => {
  const lines = text
    .split('<br/>')
    .map((chuck) => chuck.trim())
    .map((line, index) => {
      if (line === '') return <div key={index} className={styles.spacing} />;

      const chunks = line.split('|').map((chuck) => chuck.trim());
      const footerContent = chunks.map((value, index) => (
        <MarkdownComponent className={styles.markdownInline} key={index} markdownString={value} inline tag={chunks.length > 1 ? 'li' : 'div'} />
      ));
      return chunks.length > 1 ? (
        <ul className={styles.list} key={index}>
          {footerContent}
        </ul>
      ) : (
        footerContent
      );
    });

  return (
    // The extra style below is just to fix the footer on mobile when the dev selector is shown
    <footer className={classNames(styles.footer, { [styles.testFixMargin]: IS_DEVELOPMENT_BUILD })}>{lines}</footer>
  );
};

export default Footer;
